export default __webpack_public_path__ + "static/commercial-demolition-155a773b4eee0800c4f10bbbf97b9f67.jpg";